import type { AssetLocation } from "../api/types.js";

// 1.D.7 Sijaintirivien luokittelu UI:ta varten.
//
// Repository.kind = "object_storage" | "filesystem" + location-string
// kertoo onko kyseessa Hetzner Object Storage / R2 (object_storage),
// kannettava USB-levy (filesystem joka osoittaa /Volumes/* polkuun)
// vai paikallinen Mac-koneen polku (filesystem ilman /Volumes/-prefixia).
//
// Tama on heuristinen — backend ei v1:ssa tarjoa "category"-kenttaa,
// joten paatos tehdaan kindista + polusta.

export type LocationKind = "object_storage" | "usb" | "mac" | "unknown";

export type LocationView = {
  kind: LocationKind;
  /** Lyhyt label, esim. "R2", "USB", "Mac". */
  label: string;
  /** Pidempi yksilollinen kuvaus, esim. bucket-host tai mount-piste. */
  description: string;
};

export function classifyLocation(
  loc: Pick<AssetLocation, "repositoryKind" | "repositoryLocation">
): LocationView {
  const location = loc.repositoryLocation;
  if (loc.repositoryKind === "object_storage") {
    return {
      kind: "object_storage",
      label: "R2",
      description: shortenUrl(location),
    };
  }
  if (loc.repositoryKind === "filesystem") {
    if (location.startsWith("/Volumes/")) {
      const mount = location.split("/")[2] ?? location;
      return {
        kind: "usb",
        label: "USB",
        description: mount,
      };
    }
    return {
      kind: "mac",
      label: "Mac",
      description: location,
    };
  }
  return { kind: "unknown", label: "?", description: location };
}

function shortenUrl(url: string): string {
  // s3://kratti-snapshots/users/u1/ → "kratti-snapshots/users/u1"
  // https://obj.hetzner.com/.../ → "obj.hetzner.com/..."
  const m = url.match(/^([a-z0-9]+):\/\/(.+?)\/?$/i);
  if (!m) return url.replace(/\/+$/, "");
  return m[2] ?? url;
}
